/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Manager_Remove_Group_TitleInputs */

const en_team_manager_remove_group_title = /** @type {(inputs: Team_Manager_Remove_Group_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remove Group`)
};

const fr_team_manager_remove_group_title = /** @type {(inputs: Team_Manager_Remove_Group_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Supprimer le groupe`)
};

const de_team_manager_remove_group_title = /** @type {(inputs: Team_Manager_Remove_Group_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gruppe entfernen`)
};

const it_team_manager_remove_group_title = /** @type {(inputs: Team_Manager_Remove_Group_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rimuovi gruppo`)
};

const ru_team_manager_remove_group_title = /** @type {(inputs: Team_Manager_Remove_Group_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Удалить группу`)
};

const es_team_manager_remove_group_title = /** @type {(inputs: Team_Manager_Remove_Group_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eliminar grupo`)
};

const zh_cn2_team_manager_remove_group_title = /** @type {(inputs: Team_Manager_Remove_Group_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`移除组`)
};

const ja_team_manager_remove_group_title = /** @type {(inputs: Team_Manager_Remove_Group_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`グループを削除`)
};

const hi_team_manager_remove_group_title = /** @type {(inputs: Team_Manager_Remove_Group_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`समूह हटाएं`)
};

const pt_pt2_team_manager_remove_group_title = /** @type {(inputs: Team_Manager_Remove_Group_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remover grupo`)
};

/**
* | output |
* | --- |
* | "Remove Group" |
*
* @param {Team_Manager_Remove_Group_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_manager_remove_group_title = /** @type {((inputs?: Team_Manager_Remove_Group_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Manager_Remove_Group_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_team_manager_remove_group_title(inputs)
	if (locale === "de") return de_team_manager_remove_group_title(inputs)
	if (locale === "it") return it_team_manager_remove_group_title(inputs)
	if (locale === "ru") return ru_team_manager_remove_group_title(inputs)
	if (locale === "es") return es_team_manager_remove_group_title(inputs)
	if (locale === "zh-CN") return zh_cn2_team_manager_remove_group_title(inputs)
	if (locale === "ja") return ja_team_manager_remove_group_title(inputs)
	if (locale === "hi") return hi_team_manager_remove_group_title(inputs)
	if (locale === "pt-PT") return pt_pt2_team_manager_remove_group_title(inputs)
	return en_team_manager_remove_group_title(inputs)
});